export const money = (n: number, c = 'AED'): string =>
  `${c} ${Number(n || 0).toLocaleString('en-AE', { maximumFractionDigits: 0 })}`;

export const today = (): string => new Date().toISOString().slice(0, 10);

export const fmtDate = (d: string | null): string =>
  d ? new Date(`${String(d).slice(0, 10)}T00:00:00`).toLocaleDateString('en-GB',
    { day: '2-digit', month: 'short', year: '2-digit' }) : '—';

export const fmtDay = (d: string): string =>
  new Date(`${d}T00:00:00`).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' });

export const daysBetween = (from: string, to: string): number =>
  Math.round((new Date(`${to}T00:00:00Z`).getTime() - new Date(`${from}T00:00:00Z`).getTime()) / 864e5);

export const addDays = (d: string, n: number): string =>
  new Date(new Date(`${d}T00:00:00Z`).getTime() + n * 864e5).toISOString().slice(0, 10);

/** A stable colour per workflow, so the same kind of work looks the same everywhere. */
const PALETTE = ['#B57C1E', '#3D6E8F', '#0F6B5C', '#AC4034', '#6B5B95', '#728A92', '#8A6D3B'];
export const workflowColour = (workflow: string): string => {
  let h = 0;
  for (const ch of workflow) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length]!;
};

/**
 * What a rule with server-side behaviour does when completed. Such a rule has no
 * `next`, yet it is not the end of anything: the engine creates the work itself.
 * Keyed by behaviour, never by task name, so a renamed task needs no change here.
 */
const SPECIAL: Record<string, string> = {
  'contract-setup': 'sets up the contract: the rooms, the instalments and the work that follows',
  'handover-gate': 'opens the next stage once both handover tasks are done',
  'rent-schedule': "schedules the lease's rent payments",
  'start-moveout': 'starts the move-out',
  'release-room': 'releases the room',
  relist: 'puts the room back on the market',
};
export const specialEffect = (special: string): string =>
  SPECIAL[special] ?? 'runs a step on the server that creates the work that follows';
